module.exports = __webpack_public_path__ + "img/logo.d3cf1906.png";